const colours = {
    primary: '#27A94F',
    secondary: '#032139',
    tertiary: '#F4F4F4',
    gradientGrey: '#F4F4F4',
    gradientGreen: '#27A94F',
    textBlue: '#154369'
};

export default colours;